require(`./${process.env.APP_INITIAL}header.scss`);

const lbHeader = angular.module('app.lbHeader', []);

lbHeader.component('lbHeader', {
  bindings: {},
  controllerAs: 'vm',
  controller: [
    'cartService',
    '$rootScope',
    '$location',
    '$state',
    '$timeout',
    'authService',
    'settingsService',
    'itinerariesService',
    'lbDialogService',
    'beamerService',
    'AUTH_EVENTS',
    controller,
  ],
  template: require(`./${process.env.APP_INITIAL}Header.html`),
});

function controller(
  cartService,
  $rootScope,
  $location,
  $state,
  $timeout,
  authService,
  settingsService,
  itinerariesService,
  lbDialogService,
  beamerService,
  AUTH_EVENTS
) {
  let vm = this;
  vm.itinerary = itinerariesService.itinerary;
  vm.cartService = cartService;
  vm.showNotifications = !!window.beamer_config;
  vm.notificationCount = beamerService.getCount();
  vm.openNotifications = openNotifications;
  $timeout(() => {
    setUserDetails();
    $rootScope.$on(AUTH_EVENTS.loginSuccess, () => {
      setUserDetails();
    });
  });

  vm.logout = () => {
    return isActiveCart() ? openAreYouSureModal('', true) : handelLogout();
  };

  vm.goTo = (newPath) => {
    return isActiveCart() ? openAreYouSureModal(newPath) : $state.go(newPath);
  };

  vm.goMain = () => {
    if (isActiveCart()) return openAreYouSureModal();
    cartService.clear();
    itinerariesService.itinerary = null;
    return $state.go('app.home');
  };

  vm.getClass = (newPath) => {
    if (getPnr()) return newPath === '/my-bookings' ? 'active' : '';

    return getCurClassPath(newPath) === newPath ? 'active' : '';
  };

  function setUserDetails() {
    vm.userInitials = getUserDetails();
  }
  function getUserDetails() {
    vm.fullName = (settingsService.settings && settingsService.settings.UserDetails && settingsService.settings.UserDetails.UserName) || '';
    if (!vm.fullName) return 'LB';
    const nameArr = vm.fullName.split(' ');
    if (nameArr.length === 1) return nameArr[0][0];
    const firstInitial = nameArr[0][0];
    const lastInitial = nameArr[nameArr.length - 1][0];
    return `${firstInitial}${lastInitial}`;
  }
  function isActiveCart() {
    return !!cartService.items.length;
  }

  function getCurClassPath() {
    let curPath = $location.path();
    if (curPath.includes('/my-bookings')) return '/my-bookings';
    switch (curPath.toLowerCase()) {
      case '/flights':
      case '/rail':
      case '/ground':
      case '/cars':
      case '/seats':
      case '/hotels':
      case '/confirmation':
      case '/itinerary':
        return '/';
      default:
        return curPath;
    }
  }

  function getPnr() {
    return (
      (itinerariesService.itinerary &&
        itinerariesService.itinerary.Passengers &&
        itinerariesService.itinerary.Passengers[0] &&
        itinerariesService.itinerary.Passengers[0].Pnr) ||
      null
    );
  }

  function openNotifications() {
    $rootScope.$broadcast('openBeamer');
    vm.notificationCount = 0;
  }

  function openAreYouSureModal(newPath = 'app.home', doLogout = false) {
    lbDialogService
      .show({
        title: getPnr() ? 'This will quit the current modifications' : 'This will quit the current booking.',
        message: 'Are you sure you want to do this?',
        warningLevel: 'warning',
        submitButtonText: 'OK',
      })
      .then(function () {
        itinerariesService.itinerary = null;
        cartService.clear();
        if (doLogout) {
          handelLogout();
        } else {
          $state.go(newPath);
        }
      });
  }

  function handelLogout() {
    authService.logout().then(() => $rootScope.$broadcast(AUTH_EVENTS.logoutSuccess));
  }
}

export default lbHeader;



// WEBPACK FOOTER //
// ./src/components/lbHeader/index.js